<template>
  <div class="stack-over">
    <div class="stack-background" :class="show ? 'fade' : ''">
      <slot></slot>
    </div>
    <div v-if="show" class="stack-over-block"></div>
    <div v-if="show" class="stack-over-popup" :style="style">
      <slot name="overlay"></slot>
    </div>
  </div>
</template>

<style lang="scss">

  .stack-over {
    position : relative;

    .stack-background.fade {
      opacity : .5;

      @media print {
        display : none !important;
      }
    }

    .stack-over-block {
      position : absolute;
      top      : 0;
      right    : 0;
      bottom   : 0;
      left     : 0;
    }

    .stack-over-popup {
      z-index  : 2;
      position : absolute;

      @media print {
        position : relative !important;
        top      : initial !important;
        right    : initial !important;
        bottom   : initial !important;
        left     : initial !important;
      }
    }
  }

</style>

<script>
  export default {
    name: 'vuestic-stack-over',

    props: {
      show: Boolean,
      anchor: {
        type: String, // top|right|left|bottom
        default: 'top',
      },
      margin: String, // css value
    },

    computed: {
      style () {
        let opposit = {
          left: 'right',
          right: 'left',
          top: 'bottom',
          bottom: 'top',
        };
        let css = {
          top: 0,
          left: 0,
          right: 0,
          [this.anchor]: this.margin,
        };
        delete css[opposit[this.anchor]];
        return css;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/vuestic-theme/vuestic-components/vuestic-stack-over/VuesticStackOver.vue